// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__4QX79","select":"Header_select__2d8Uw","clinic":"Header_clinic__1IDCE"};